import { useEffect, useState } from "react";
import axios from "axios";
import api from "../../api/axios";
import EtatBadge from "../../components/RendezVous/EtatBadge";
import { updateEtatRendezVous} from "../../api/rendezVousService.api";
import {getRendezVousAujourdhui} from "../../api/techniciens.api";
import "./Dash.css";
const formatDateFR = (dateISO) => {
  const date = new Date(dateISO);
  return date.toLocaleDateString("fr-CA");
};
export default function DashboardTechnicien() {
  const [stats, setStats] = useState({});
  const [rdvs, setRdvs] = useState([]);
useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    
    const statsRes = await api.get("/technicien/stats",
  {
    headers: {
       Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
  }
);
const rdvRes = await getRendezVousAujourdhui();
      setStats(statsRes.data);
      setRdvs(rdvRes.data);
         
  };
 
  
const handleChangeEtat = async (id, newEtat) => {
  try {
    console.log(newEtat);
    
    await updateEtatRendezVous(id, {
      etat_travaux: newEtat
    });
    loadData(); // recharger les rendez-vous pour refléter le changement
  } catch (err) {
    console.error("Erreur lors du changement d'état :", err);
  }
};
return (
  <div>
      <h1>📊 Dashboard Technicien</h1>

        <div className="dashboard-grid">
                <StatCard title="Total RDV" value={stats.total} color="#555" />
                <StatCard title="Terminés" value= {stats.termine} color="#2e7d32" />
                <StatCard title="En cours" value={stats.en_cours} color="#1976d2" />
                <StatCard title="En attente" value={stats.en_attente} color="#9e9e9e" />
                <StatCard
                  title="Heures travaillées"
                  value= {stats.total_heures +"h" || 0 +"h"}
                  color="#ff9800"
                />
        </div>
    {/* LISTE RDV */}
          <h2>📅 mes rendez vous aujourd hui </h2>
              <table className="responsive-table">
                <thead>
                  <tr>
                   <th>Client</th>
                    <th>Téléphone</th>
                    <th>Adresse</th>
                    <th>Date</th>
                    <th>Type d'entretien</th>
                    <th>Heure</th>
                    <th>État</th>
                  </tr>
                </thead>
                  <tbody>
              {rdvs.length === 0 ? (
                <tr>
                  <td colSpan="4">Aucun rendez-vous aujourd’hui</td>
                </tr>
              ) : (
                rdvs.map(r => (
                  <tr key={r.id}>
                    <td data-label="Client">{r.client}</td>
                    <td data-label="Téléphone">
                       <a href={`tel:${r.telephone}`} className="phone-link">{r.telephone}</a>
                      </td>
                    <td data-label="Adresse">{r.adresse}</td>
                    <td data-label="Date">{formatDateFR(r.date_rdv)}</td>
                    <td data-label="Type d'entretien">
                      { r.type_entretien}
                    </td>
                    <td data-label="Heure">{r.heure_debut} - {r.heure_fin}</td>
                    <td data-label="Etat">
                      {r.etat_travaux === "TERMINE" ? (
                        <EtatBadge etat={r.etat_travaux} />
                    ) : (
                        <select
                        value={r.etat_travaux}
                        onChange={(e) => handleChangeEtat(r.id, e.target.value)}
                        >
                        <option value="EN_ATTENTE">En attente</option>
                        <option value="EN_COURS">En cours</option>
                        <option value="TERMINE">Terminé</option>
                        </select>
                    )}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
         </table>
    </div>
  );
}
/* =======================
   COMPOSANT CARTE
======================== */

const StatCard = ({ title, value, color }) => {
  return (
    <div className="stat-card" style={{ borderLeftColor: color }}>
      <p className="stat-title">{title}</p>
      <p className="stat-value">{value}</p>
    </div>
  );
};